import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThemeService, PALETTE_OPTIONS, Palette } from './theme.service';

@Component({
    selector: 'app-palette-picker',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule
    ],
    template: `
    <button mat-icon-button [matMenuTriggerFor]="paletteMenu" matTooltip="Elegir tema de color">
      <mat-icon>palette</mat-icon>
    </button>
    <mat-menu #paletteMenu="matMenu">
      @for (option of paletteOptions; track option.id) {
        <button mat-menu-item (click)="setPalette(option.id)">
          <mat-icon>{{ option.icon }}</mat-icon>
          <span>{{ option.label }}</span>
          @if (themeService.palette() === option.id) {
            <mat-icon class="check-icon">check</mat-icon>
          }
        </button>
      }
    </mat-menu>
  `,
    styles: [`
    .check-icon {
      margin-left: auto;
      font-size: 18px;
      width: 18px;
      height: 18px;
      color: var(--primary);
    }
    ::ng-deep .mat-mdc-menu-item {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  `]
})
export class PalettePickerComponent {
    readonly themeService = inject(ThemeService);
    readonly paletteOptions = PALETTE_OPTIONS;

    setPalette(palette: Palette) {
        this.themeService.setPalette(palette);
    }
}
